import { render, staticRenderFns } from "./demoEscuela.vue?vue&type=template&id=03728ece"
import script from "./demoEscuela.vue?vue&type=script&lang=js"
export * from "./demoEscuela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports